export default __webpack_public_path__ + "static/media/icon-answer-check.37919c3f.svg";